<template>
	<div class="blacklist-index">
		<ul class="module-item-style clearfix blacklist-tab">
			<li @click="linkToPage('/setting-advanced-visitor-blacklist')" :class="showTab ? 'tabActived' : ''">访客黑名单</li>
			<li @click="linkToPage('/setting-advanced-ip-blacklist')" :class="!showTab ? 'tabActived' : ''">IP黑名单</li>
		</ul>
		<div style="margin-top: 15px;">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'blacklist-index',
		data() {
			return {
				showTab: false
			}
		},
		watch: {
			'$route'(to, from) {
				if (to.path == '/setting-advanced-visitor-blacklist') {
					this.showTab = true
				} else {
					this.showTab = false
				}
			}
		},
		created() {
			let currentRoute = this.$route.path
			if (currentRoute == '/setting-advanced-visitor-blacklist') {
				this.showTab = true
			} else {
				this.showTab = false
			}
		},
		mounted() {

		},
		methods: {
			linkToPage(pathName) {
				this.$router.push({
					path: pathName
				})
			},
		}
	}
</script>

<style lang="scss">
	.blacklist-index {

		.blacklist-tab {
			li+li {
				margin-left: 20px;
			}

			li {
				float: left;
				cursor: pointer;
				padding-bottom: 7px;

				&.tabActived {
					border-bottom: 5px solid #428EFE;
				}
			}
		}
	}
</style>
